'use client'

import { useEffect, useState } from 'react'
import { Check, Copy } from '@/components/ui/icons'

// Copies a command to the clipboard and confirms for a moment. The command itself stays in
// the server-rendered markup next to it; this only adds the button.
export function CopyButton({ text, className = '' }: { text: string; className?: string }) {
  const [copied, setCopied] = useState(false)

  useEffect(() => {
    if (!copied) return
    const t = setTimeout(() => setCopied(false), 1600)
    return () => clearTimeout(t)
  }, [copied])

  return (
    <button
      type="button"
      onClick={() => {
        navigator.clipboard
          .writeText(text)
          .then(() => setCopied(true))
          .catch(() => setCopied(false))
      }}
      aria-label={copied ? 'Copied' : 'Copy command'}
      data-copied={copied || undefined}
      className={`inline-flex h-8 shrink-0 items-center gap-1.5 rounded-lg border border-white/[0.12] px-2.5 text-[12px] text-white/60 transition-colors hover:border-white/30 hover:text-white ${className}`}
    >
      {copied ? <Check className="h-3.5 w-3.5" /> : <Copy className="h-3.5 w-3.5" />}
      <span>{copied ? 'Copied' : 'Copy'}</span>
    </button>
  )
}
